export default __webpack_public_path__ + "static/media/549.d57d1efc.png";